
<template>
  <div class="modal-mask" tabindex="0">
    <div class="modal-wrapper" v-on:click.prevent>
      <div :class="{ [`modal-dialog modal-${size}`]: true, 'calc': calcHeight }" role="document" v-on:click.stop>
        <div class="modal-content">
          <div ref="header" class="modal-header" style="padding-bottom: 0;">
            <button v-if="showClose" type="button" class="close" v-on:click="$emit('close-modal')">
              <span aria-hidden="true">&times;</span>
            </button>
            <slot name="header" />
          </div>

          <div class="modal-body">
            <slot name="body" v-if="!loading" />
            <Loader :text="loadingText" v-else :margin="50" />
          </div>
          <slot name="footer" v-if="!loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../Loader";

export default {
  components: { Loader },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: "Laddar ..."
    },
    calcHeight: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "lg"
    }
        },
        mounted() {            
            this.$nextTick(() => {
                document.body.classList.add("modal-open");
            });
        },
        unmounted() {            
            document.body.classList.remove("modal-open");
        }
};
</script>

<style scoped lang="scss">
    @media (min-width: 1180px) {
        .modal-lg {
            width: 1100px;
        }

        .modal-md {
            width: 800px;
        }
    }

    @media (min-width: 1200px) {
        .modal-lg {
            width: 1180px;
        }

        .modal-md {
            width: 800px;
        }
    }

    @media (min-width: 1300px) {
        .modal-lg {
            width: 1280px;
        }

        .modal-md {
            width: 800px;
        }
    }

    @media (min-width: 1400px) {
        .modal-lg {
            width: 1380px;
        }

        .modal-md {
            width: 800px;
        }
    }

    @media (min-width: 1500px) {
        .modal-lg {
            width: 1480px;
        }

        .modal-md {
            width: 800px;
        }
    }

    @media (min-width: 1600px) {
        .modal-lg {
            width: 1580px;
        }

        .modal-md {
            width: 800px;
        }
    }

    @media (min-width: 1900px) {
        .modal-lg {
            width: 1880px;
        }

        .modal-md {
            width: 1000px;
        }
    }

.calc {
  height: calc(100vh - 60px);

  .modal-content {
    display: flex;
    flex-direction: column;
    height: 100%;

    .modal-body {
      flex-grow: 1;
    }
  }
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-header h3 {
  margin: 0;
  margin-bottom: 1rem;
}

.modal-body {
  overflow-y: auto;
}

.modal-body.calc {
  height: calc(100vh - 212px);
}

.modal-header {
  border-bottom: none;
}

.close {
  font-size: 2.5em;
}
</style>